// extracted by mini-css-extract-plugin
export default {"root":"ImageGroup_root__xaevS","group-photo":"ImageGroup_group-photo__SYHWw"};